// モーダル表示時に背景スクロールを禁止する
const bodyScrollPrevent = (flag) => {
	let scrollPosition;
	const body = document.getElementsByTagName('body')[0];
	const ua = window.navigator.userAgent.toLowerCase();
	const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;
	const scrollBarWidth = window.innerWidth - document.body.clientWidth;
	if (flag) {
		body.style.paddingRight = scrollBarWidth + 'px';
		scrollPosition = -window.pageYOffset;
		body.style.top = scrollPosition + 'px';
		if (isiOS) {
			body.style.position = 'fixed';
			body.style.width = '100%';
		} else {
			body.style.overflow = 'hidden';
			body.style.position = 'fixed';
			body.style.width = '100%';
		}
	} else if (!flag) {
		body.style.paddingRight = '';
		scrollPosition = parseInt(body.style.top.replace(/[^0-9]/g, ''));
		if (isiOS) {
			body.style.position = '';
			body.style.width = '';
			body.style.top = '';
		} else {
			body.style.overflow = '';
			body.style.position = '';
			body.style.width = '';
		}
		window.scrollTo(0, scrollPosition);
	}
}

// スクロールのドラッグ有効化
jQuery.prototype.mousedragscrollable = function () {
  let target;
  $(this).each(function (i, e) {
    $(e).mousedown(function (event) {
      event.preventDefault();
      target = $(e);
      $(e).data({
        down: true,
        move: false,
        x: event.clientX,
        y: event.clientY,
        scrollleft: $(e).scrollLeft(),
        scrolltop: $(e).scrollTop(),
      });
      return false;
    });
    $(e).click(function (event) {
      if ($(e).data("move")) {
        return false;
      }
    });
  });
  $(document)
    .mousemove(function (event) {
      if ($(target).data("down")) {
        event.preventDefault();
        let move_x = $(target).data("x") - event.clientX;
        let move_y = $(target).data("y") - event.clientY;
        if (move_x !== 0 || move_y !== 0) {
          $(target).data("move", true);
        } else {
          return;
        }
        $(target).scrollLeft($(target).data("scrollleft") + move_x);
        $(target).scrollTop($(target).data("scrolltop") + move_y);
        return false;
      }
    })
    .mouseup(function (event) {
      $(target).data("down", false);
    });
};
$(".scroll").mousedragscrollable();

const observeAppDOM = () => {
	const target = document.querySelector('.list_by_app');
	const observer = new MutationObserver((records, obs) => {
		records.forEach((record) => {
			if (target && record.type === 'childList') {
				const productListElement = target.querySelector('.evm-wsrow');
				if (productListElement && productListElement.children) {
					obs.disconnect();
					$(".list_by_app .evm-wsrow").mousedragscrollable();
				}
			}
		})
	})
	observer.observe(target, {
		childList: true,
		subtree: true,
	});
}

//100vh - ヘッダーパンくず
$(window).on('load resize', function(){
	var windowH = $(window).height();
	var headerH = $('header').innerHeight();
	var breadcrumbsH = 0;
	if($('.breadcrumbs').length){
	   breadcrumbsH = $('.breadcrumbs').innerHeight();
	}
	if (window.innerWidth < 960) {
		breadcrumbsH = 0;
	}
	var vh100 = windowH - headerH - breadcrumbsH;
	$('.vh100').css({height: vh100});
});

$(function() {

	//ハンバーガーメニュー
	var nav = false;
	var scrollPosition;
	var scrollPositionLocked;
	$(window).on('scroll load', function(event) { scrollPosition = $(window).scrollTop(); });
	$('.gmenu-btn').on('click', function(event) {
		$('.header_ec-gnav').toggleClass('gmenu-open');

		const headerShipping = document.querySelector(".header-shipping");
		headerShipping.style.display = "none";
	
		if(!nav) {
			event.preventDefault();
			scrollPositionLocked = scrollPosition;
			$('#wrap').addClass('is-locked');
			$('#wrap').css({top: - scrollPosition});
			$('.ec_search-suggest').hide();
			$('.gmenu').show();
			nav = true;
		} else {
			event.preventDefault();
			$('#wrap').removeClass('is-locked');
			$(window).scrollTop(scrollPositionLocked);
			$('.gmenu').hide();
			$('.gmenu').removeClass('is-locked');
			$('.gmenu_nav-layer').removeClass('show');
			nav = false;
		}
	});
	
	//ハンバーガー2階層目　開閉
	$('.gmenu_nav-layer_btn').on('click', function(event) {
		$(this).next('.gmenu_nav-layer').addClass('show');
		$('.gmenu').addClass('is-locked');
	});
	$('.menu-back').on('click', function(event) {
		$(this).parents('.gmenu_nav-layer').removeClass('show');
		$('.gmenu').removeClass('is-locked');
	});

	//ハンバーガー3階層目　開閉
	$('.gmenu_nav-layer_sub_btn').on('click', function(event) {
		$(this).next('.gmenu_nav-layer.sub').addClass('show');
	});
	$('.sub-menu-back').on('click', function(event) {
		$(this).parents('.gmenu_nav-layer.sub').removeClass('show');
	});
	
	//検索結果　並び替え選択
	$('.search_sort-toggle').on('click', function(event) {
		$('.search_sort-list').slideToggle(100);
	});
	$('.search_sort-list li').on('click', function(event) {
		var sort = $(this).text();
		$('.search_sort-list li').removeClass('check');
		$(this).addClass('check');
		$('.search_sort-word span').text(sort);
		$("#sort-by").data('sortValue', $(this).data('sortValue'));
		$('.search_sort-list').slideUp(100);
	});
	
	//検索結果　検索条件 filterClose
	$('.search_sort-filter').on('click', function(event) {
		event.preventDefault();
		scrollPositionLocked = scrollPosition;
		$('#wrap').addClass('is-locked');
		$('#wrap').css({top: - scrollPosition});
		$('.search-matching').show();
	});
	$('.filterClose').on('click', function(event) {
		event.preventDefault();
		$('#wrap').removeClass('is-locked');
		$(window).scrollTop(scrollPositionLocked);
		$('.search-matching').hide();
	});
	
	//カード aタグ内のリンク
	$('.js-link').hover(
		function (){
			$(this).parents('.cardimglink').addClass('noimghover');
		},
		function () {
			$(this).parents('.cardimglink').removeClass('noimghover');
		}
	);
	$('.js-link').on('click', function(e){
		e.stopPropagation();
		e.preventDefault();
		location.href = $(this).attr('data-url');
	});
	
	//ご利用ガイド・よくある質問　ページ内リンク
	$('.staticWrap a[href^="#"]').click(function () {
		const speed = 600;
		let href = $(this).attr("href");
		let target = $(href == "#" || href == "" ? "html" : href);
		let headerH = $('header').innerHeight();
		let position = target.offset().top - headerH;
		$("body,html").animate({ scrollTop: position }, speed, "swing");
		return false;
	});

	// アプリで出力するDOMの監視
	observeAppDOM();
	
});






